module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"no_item_message":{"none":"暂无商品。","filtered":"没有符合条件的商品。"}}}')
  delete Component.options._Ctor
}
